<style lang="less">
.github-markdown-body {
	padding: 0;
	font-size: 14px;

	li > p {
		margin-top: 3px !important;
	}
	li {
		white-space: normal;
		margin: 0;
		padding: 0;
	}

	.v-md-pre-wrapper {
		border: 1px solid var(--border);
		margin-right: 30px;
		background: #33333311 !important;

		pre {
			white-space: pre-wrap;
			code {
			}
		}
		pre::-webkit-scrollbar {
			height: 8px;
		}

		margin-bottom: 20px;
	}

	ol {
		margin:0;
		margin-block-end: -1em;
		height:auto !important;
		margin-block-start:-1.5em;
		line-height:23px;
		box-sizing: border-box;
		li {
			margin:0;
			padding-top:0;
			margin-block-start: 0em;
	}
	}

	.v-md-hljs- {
		margin: 0;
	}
	li::marker {
		display: inline;
	}
	p {
		margin: 0;
		line-height:23px;
		padding: 0;
		    margin-block-start: 0em !important;
	}
}

.github-markdown-body div[class*="v-md-pre-wrapper-"].line-numbers-mode:after {
	background: none;
}
.hover-button {
	background: var(--bg1) !important;
}
.hover-button:hover {
	cursor: pointer;

	background: var(--primary) !important;
	i {
	}
}

.l-memo{

}
</style>
<template>
	<div class="container flex-wrap flex-line align-stretch" style="width: 100%">
		<div
			style="width: 200px; flex-shrink: 0; position: relative"
			v-if="chatMode"
		>
			<div
				class="l-chat-item"
				@click="select_chat()"
				style="height: 50px"
				:class="{ 'l-chat-item-active': selected_chat_id == null }"
			>
				<BaseIcon icon="ios-add" :size="20" style="margin-right: 5px" />新对话
			</div>
			<div style="height: calc(100% - 50px); overflow-y: auto">
				<template v-for="c in chats">
					<div
						class="l-chat-item flex-between"
						:key="`chat_${c?c.id:null}${rid}`"
						@click="select_chat(c)"
						:class="{ 'l-chat-item-active': selected_chat_id == c.id }"
					>
						{{ c.title }}

						<div
							class="flex-wrap flex-center"
							style="
								padding: 2px;
								border: 1px solid var(--border);
								border-radius: 50%;
							"
						>
							<BaseIcon
								:size="15"
								icon="ios-remove"
								color="var(--text3)"
								@click="removeChat(c.id)"
							/>
						</div>
					</div>
				</template>
			</div>
		</div>
		<div
			class="container l-memo"
			style="flex-grow: 1; width: 100%"
			:style="chatMode ? 'padding-top:10px;height:calc(100% - 10px)' : ''"
		>
			<div
				class="flex-wrap flex-between"
				style="margin-bottom: 10px; color: var(--text3); width: 100%"
			>
				<div class="flex-wrap">
					<Select
						style="width: 200px"
						v-model="aimode"
						@on-select="localSaveMode"
					>
						<!-- <Option value="openai">普通AI</Option>
          <Option value="image">绘图</Option> -->
						<Option value="gpt">ChatGPT-3.5</Option>
					</Select>
					<Button
						style="
							margin-left: 10px;
							background: var(--bg3);
							color: var(--text3);
						"
						@click="clearAll"
						v-if="items.length > 0"
						>清空</Button
					>
					<Button style="margin-left: 10px" @click="showHelp = true"
						>新人必读</Button
					>
				</div>
			</div>

			<div
				ref="chatbox"
				style="
					overflow-y: auto;
					height: calc(100% - 85px);
					margin-top: 10px;
					border: 1px solid var(--border);
					scroll-behavior: smooth;
					font-size: 16px;
					padding:10px;
					padding-bottom: 50px;
					border-radius: 5px;
					background: var(--bg3);
					color: var(--text3);
					width: 100%;
				"
			>
				<BaseEmpty v-if="items.length == 0 && !loading">
					<div class="flex-col" style="color: var(--text3)">
						<svg
							width="35"
							style="margin: 10px 0; margin-top: 50px; flex-shrink: 0"
							height="35"
							viewBox="0 0 41 41"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							strokewidth="2"
							class="scale-appear"
						>
							<path
								d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z"
								fill="var(--subtext3)"
							></path>
						</svg>
						<div style="margin: 10px 20px">
							<p style="color: var(--primary)">请开启您的GPT之旅吧！</p>
						</div>
					</div>
				</BaseEmpty>
				<Spin v-if="loading">
					<BaseLoading />
				</Spin>
				<div v-for="(item,index) in items" :key="'quest_'+rid+index" style="margin-top: 10px;border-bottom:2px dashed var(--border);">
					<div
						class="flex-wrap flex-line align-start"
						style="padding: 10px; font-size: 14px;font-weight:bold;"
					>
						<BaseAvatar
							:src="session.avatar"
							size="small"
							style="flex-shrink: 0; margin-right: 10px"
						/>{{ item.q
						}}<BaseIcon
							@click="remove(item.id)"
							class="hover-button"
							icon="md-trash"
							:size="16"
							color="#fff"
							style="
								margin-left: 10px;
								background: var(--bg3);
								border-radius: 2px;
								padding: 2px;
							"
						></BaseIcon>
						<BaseIcon
							title="重发"
							@click="resend(item)"
							class="hover-button"
							icon="ios-send"
							:size="16"
							color="#fff"
							style="
								margin-left: 5px;
								border-radius: 2px;
								background: var(--bg3);
								padding: 2px;
							"
						></BaseIcon>
					</div>

					<div
						class="flex-wrap flex-line align-start"
						style="
							color: var(--text3);
							white-space: pre-wrap;
							padding: 10px;
							font-size: 14px;
						"
					>
						<svg
							width="25"
							style="margin-right: 10px; flex-shrink: 0"
							height="25"
							viewBox="0 0 41 41"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							strokewidth="2"
							class="scale-appear"
						>
							<path
								d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z"
								fill="currentColor"
							></path>
						</svg>
						<div
							class="flex-col align-start"
							style="position: relative; width: 100%"
						>
							<div
								style="
									font-size: 12px;
									color: var(--text3);
									padding: 2px 5px;
									border-radius: 5px;
									border: 1px solid var(--border);
									line-height: 12px;
									margin-bottom: 5px;
									height: 20px;
								"
								class="flex-wrap"
								v-if="!item.state"
							>
								{{ item.mode || "openAI" }} <BaseLoading style="width: 30px" />
							</div>
							<template v-if="item.state">
								<template v-if="item.mode == 'image'">
									<img :src="item.a" style="width: 200px; height: 200px" />
								</template>
								<template v-else>
									<v-md-editor
										:value="item.a"
										mode="preview"
										style="background: none; margin-top: -3px"
										:style="item.state == 2 ? 'color:var(--error)' : ''"
									></v-md-editor>
								</template>
							</template>
						</div>
					</div>
					<!-- <div
						style="
							color: var(--subtext3);
							font-size: 10px;
							margin-left: 10px;
							opacity: 0.5;
							filter: grayscale(1);
						"
						class="flex-wrap"
						v-if="item.state == 1"
					>
						本条消耗<BaseAmount
							:precision="5"
							full
							:value="(item.total_tokens * 0.013) / 1000"
							style="margin-left: 10px; margin-right: 5px"
						></BaseAmount>
						元
					</div> -->
				</div>
			</div>
			<div class="flex-wrap flex-line" style="margin-top: 10px">
				<Input
					size="large"
					v-model="q"
					placeholder="请详细描述您想问的问题 (按Enter可直接发送）"
					@on-enter="submit()"
				/><Button
					size="large"
					@click="submit()"
					icon="ios-send"
					style="
						margin-left: 10px;
						border-radius: 3px;
						height: 40px;
						width: 44px;
					"
					type="primary"
					:loading="loading"
					:disabled="!q"
				/>
			</div>
		</div>
		<Modal v-model="showHelp" title="新人必读">
			<p>以下是关于CHATGPT的一些使用说明：</p>
			<p>
				1、目前AI提接口为chatpgpt3.5接口，训练<span
					style="color: var(--primary)"
					>数据截止于2021年9月，因此无法提供实时的数据查询</span
				>
			</p>
			<p>
				2、我们这个接口目前<span style="color: var(--primary)"
					>没有提供上下文（记忆）功能</span
				>，请完整描述每个需要咨询的问题
			</p>
			<p>
				3、越丰富的问题得到的结果才会越准确，比如“写一个工作总结”，肯定没有“我是xx公司的一名员工，2022年度我做了工作：1,2,3,4,5，请帮我写一篇工作总结”这样得到的结果准确。
			</p>
			<p>
				4、AI给出的结果并不一定是完全正确的，仅供参考，请注意甄别。<span
					style="color: var(--primary)"
					>尤其是专业知识及相关政策，他训练数据有限，会返回一些现编的错误结果</span
				>，请谨慎对待
			</p>
			<p style="color: var(--primary)">
				5、为了信息安全考虑，请不要把涉密或者敏感的信息发送给AI处理
			</p>
			<p>
				6、支持大段文字的发送，比如你可以粘贴一段文字发给他，让他提出修改意见
			</p>
			<p>
				7、AI的应用方式有很多种，比如：写文章，修改文章，提炼要点，根据文章设计PPT，编写各类公文。可以通过抖音搜索相关内容，充分发掘AI的潜力
			</p>
		</Modal>
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import UTIL from '@/utils';
export default {
  data() {
    return {
      q: '',
      loading: false,
      showHelp: false,
      selected_chat_id: null,
      aimode: 'gpt',
      items: [],
      chats: [
        {
          name: '新对话',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('session', ['session']),
  },
  props: {
    'chat-mode': {
      type: Boolean,
      default: false,
    },
    'rid': {
      type: Number,
      default: Math.random(),
    },
  },

  activated() {
    clearInterval(this.pendingInterval);
    this.getData(null, true);
  },
  beforeDestroy() {
    clearInterval(this.pendingInterval);
  },
  methods: {
    localSaveMode(e) {
      localStorage.setItem('ai-mode', e.value);
    },
    select_chat(chat) {
      if (chat) {
        if (chat.id == this.selected_chat_id) return;
        this.selected_chat_id = chat.id;
        this.getData(chat.id);
      } else {
        this.selected_chat_id = null;
        if (this.pendingInterval) clearInterval(this.pendingInterval);
        this.items = [];
      }
    },
    getData(id, once) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        if (!id && this.chatMode) {
          this.$api.get('ai?q=chat').then((res) => {
            this.chats = res.data.data;
            if (this.selected_chat_id) {
              this.getData(this.selected_chat_id, once);
            }
          }).finally(()=>{
            delete this.timer;
          });
        } else {
          this.items = [];
          this.loading = true;
          this.$api
              .get(id ? `ai?chat=${id}` : 'ai')
              .then((res) => {
                this.items = res.data.data;
                if (!once) {
                  //	this.startPending();

                } else {
                  this.$nextTick(() => {
                    if (this.scrollTimer) clearTimeout(this.scrollTimer);
                    this.scrollTimer = setTimeout(() => {
                      if (this.$refs.chatbox) {
                        this.$refs.chatbox.scrollTop =
												this.$refs.chatbox.scrollHeight;
                      }
                    }, 300);
                  });
                }
              })
              .finally(() => {
                this.loading = false;
              });
        }
      }, 1000);
    },

    resend(item) {
      this.submit(item.q);
    },
    removeChat(id) {
      this.Confirm('确定删除这次对话', () => {
        clearInterval(this.pendingInterval);
        this.$api.delete('ai/' + id + '?q=chat').then((res) => {
          const index = this.chats.findIndex((v) => v.id == id);
          this.chats.splice(index, 1);

          this.select_chat(index > 0 ? this.chats[index - 1] : null);
        });
      });
    },
    remove(id) {
      this.Confirm('确认删除此条问答?', () => {
        this.$api.delete('ai/' + id).then((res) => {
          this.items.splice(
              this.items.findIndex((v) => v.id == id),
              1,
          );
        });
      });
    },
    clearAll() {
      this.Confirm('确认清除所有历史信息?', () => {
        clearInterval(this.pendingInterval);
        this.$api.post('ai/clear').then((res) => {
          this.items = [];
        });
      });
    },
    startPending() {
      if (this.pendingInterval) {
        clearInterval(this.pendingInterval);
      }
      if (
        this.items.filter((v) => !v.state).filter((v) => !v.state).length > 0
      ) {
        this.pendingInterval = setInterval(() => {
          const idlist = this.items.filter((v) => !v.state).map((v) => v.id);
          if (idlist.length == 0) {
            clearInterval(this.pendingInterval);
            this.pendingInterval = null;
          }
          this.$api.post('ai/pending', idlist).then((res) => {
            const items = res.data.data;
            items.forEach((v) => {
              if (v.a) {
                v.a = v.a.replaceAll('\n\n', '\n');
                v.a = v.a.replace(/^\n/g, '');
                v.total_tokens = v.total_tokens;
              }
              UTIL.updateItem(this.items, v);
            });
            if (items.length > 0) {
              if (this.scrollTimer) clearTimeout(this.scrollTimer);
              this.scrollTimer = setTimeout(() => {
                this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
              }, 500);
            }
          });
        }, 5000);
      } else {
        clearInterval(this.pendingInterval);
      }
    },

    submit(def_q) {
      const index = this.items.length;
      const q = def_q || this.q;
      if (!q) return;
      this.q = '';
      this.loading = true;
      this.items.push({q});
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.$refs.chatbox.scrollTop = this.$refs.chatbox.scrollHeight;
      }, 300);
      let url = '/ai';

      if (this.useImage) {
        this.aimode = 'image';
      }
      if (this.aimode !== 'default') {
        url += '?q=' + this.aimode;
      }

      if (this.chatMode) {
        url += '&c=chat';
      }
      this.$api
          .post(
              url,
              {prompt: q, chat_id: this.selected_chat_id},
              {timeout: 300000},
          )
          .then((res) => {
            const {id, a, mode, state, chat_id} = res.data.data;
            if (chat_id && !this.selected_chat_id) {
              this.getData();
              this.selected_chat_id = chat_id;
            } else {
					  this.startPending();
            }
            this.items.splice(index, 1, {id, q, a, mode, state});
          })
          .catch((e) => {
            this.items.splice(index, 1, {q, a: e, state: 2});
            this.Error(e);
          })
          .finally((e) => {
            this.loading = false;
          });
    },
  },
};
</script>

<style lang="less">
.l-memo {
	border-radius: 5px;
	padding: 0px 10px;
	padding-bottom: 10px;
	.ivu-input {
		border-color: var(--border);
		color: var(--text3) !important;
	}

	.ivu-btn-primary {
		background: var(--primary);
		border-color: var(--border);
		border-radius: 0;
	}
	.ivu-select {
		.ivu-select-selection {
			color: var(--text3) !important;
		}
	}
	.ivu-btn[disabled] {
		background: #33333355 !important;
		i {
			color: var(--hover-text);
		}
		border-color: var(--border);
	}
}

.l-chat-item {
	background: var(--bg3);
	padding: 10px;
	display: flex;
	align-items: center;
	width: 100%;
	line-height: 20px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: flex;
	overflow: hidden;
	border-bottom: 1px solid var(--border);
	cursor: pointer;
}

.l-chat-item:hover {
	color: var(--primary);
}

.l-chat-item-active {
	background: var(--primary);
	color: var(--hover-text);
}

.l-chat-item-active:hover {
	color: var(--hover-text);
}
</style>
